// Country dial codes — Americas + Western Europe (occidental).
// Order:
//   1) US + Canada (priority — same +1 dial, north-of-border shared)
//   2) Rest of Americas, alphabetical by display name
//   3) Western Europe, alphabetical by display name
// Each entry: iso, flag emoji, display name, dial (with +).
export const COUNTRY_CODES = [
  // Priority — +1
  { iso: "US", flag: "🇺🇸", name: "United States", dial: "+1" },
  { iso: "CA", flag: "🇨🇦", name: "Canada", dial: "+1" },

  // Rest of Americas — alphabetical
  { iso: "AR", flag: "🇦🇷", name: "Argentina", dial: "+54" },
  { iso: "BS", flag: "🇧🇸", name: "Bahamas", dial: "+1" },
  { iso: "BZ", flag: "🇧🇿", name: "Belize", dial: "+501" },
  { iso: "BO", flag: "🇧🇴", name: "Bolivia", dial: "+591" },
  { iso: "BR", flag: "🇧🇷", name: "Brasil", dial: "+55" },
  { iso: "CL", flag: "🇨🇱", name: "Chile", dial: "+56" },
  { iso: "CO", flag: "🇨🇴", name: "Colombia", dial: "+57" },
  { iso: "CR", flag: "🇨🇷", name: "Costa Rica", dial: "+506" },
  { iso: "CU", flag: "🇨🇺", name: "Cuba", dial: "+53" },
  { iso: "EC", flag: "🇪🇨", name: "Ecuador", dial: "+593" },
  { iso: "SV", flag: "🇸🇻", name: "El Salvador", dial: "+503" },
  { iso: "GT", flag: "🇬🇹", name: "Guatemala", dial: "+502" },
  { iso: "GY", flag: "🇬🇾", name: "Guyana", dial: "+592" },
  { iso: "HT", flag: "🇭🇹", name: "Haití", dial: "+509" },
  { iso: "HN", flag: "🇭🇳", name: "Honduras", dial: "+504" },
  { iso: "JM", flag: "🇯🇲", name: "Jamaica", dial: "+1" },
  { iso: "MX", flag: "🇲🇽", name: "México", dial: "+52" },
  { iso: "NI", flag: "🇳🇮", name: "Nicaragua", dial: "+505" },
  { iso: "PA", flag: "🇵🇦", name: "Panamá", dial: "+507" },
  { iso: "PY", flag: "🇵🇾", name: "Paraguay", dial: "+595" },
  { iso: "PE", flag: "🇵🇪", name: "Perú", dial: "+51" },
  { iso: "PR", flag: "🇵🇷", name: "Puerto Rico", dial: "+1" },
  { iso: "DO", flag: "🇩🇴", name: "República Dominicana", dial: "+1" },
  { iso: "SR", flag: "🇸🇷", name: "Surinam", dial: "+597" },
  { iso: "TT", flag: "🇹🇹", name: "Trinidad & Tobago", dial: "+1" },
  { iso: "UY", flag: "🇺🇾", name: "Uruguay", dial: "+598" },
  { iso: "VE", flag: "🇻🇪", name: "Venezuela", dial: "+58" },

  // Western Europe (occidental) — alphabetical
  { iso: "DE", flag: "🇩🇪", name: "Alemania", dial: "+49" },
  { iso: "AD", flag: "🇦🇩", name: "Andorra", dial: "+376" },
  { iso: "AT", flag: "🇦🇹", name: "Austria", dial: "+43" },
  { iso: "BE", flag: "🇧🇪", name: "Bélgica", dial: "+32" },
  { iso: "DK", flag: "🇩🇰", name: "Dinamarca", dial: "+45" },
  { iso: "ES", flag: "🇪🇸", name: "España", dial: "+34" },
  { iso: "FI", flag: "🇫🇮", name: "Finlandia", dial: "+358" },
  { iso: "FR", flag: "🇫🇷", name: "Francia", dial: "+33" },
  { iso: "IE", flag: "🇮🇪", name: "Irlanda", dial: "+353" },
  { iso: "IS", flag: "🇮🇸", name: "Islandia", dial: "+354" },
  { iso: "IT", flag: "🇮🇹", name: "Italia", dial: "+39" },
  { iso: "LI", flag: "🇱🇮", name: "Liechtenstein", dial: "+423" },
  { iso: "LU", flag: "🇱🇺", name: "Luxemburgo", dial: "+352" },
  { iso: "MT", flag: "🇲🇹", name: "Malta", dial: "+356" },
  { iso: "MC", flag: "🇲🇨", name: "Mónaco", dial: "+377" },
  { iso: "NO", flag: "🇳🇴", name: "Noruega", dial: "+47" },
  { iso: "NL", flag: "🇳🇱", name: "Países Bajos", dial: "+31" },
  { iso: "PT", flag: "🇵🇹", name: "Portugal", dial: "+351" },
  { iso: "GB", flag: "🇬🇧", name: "Reino Unido", dial: "+44" },
  { iso: "SE", flag: "🇸🇪", name: "Suecia", dial: "+46" },
  { iso: "CH", flag: "🇨🇭", name: "Suiza", dial: "+41" },
];

export const DEFAULT_COUNTRY_ISO = "US";
